import { Component, inject } from '@angular/core';
import { CacTableComponent, table } from '@controladad/ng-base';
import { TagApiService } from '@core';
import { TagEntity } from '@models';

@Component({
  selector: 'app-tags',
  standalone: true,
  imports: [CacTableComponent],
  templateUrl: './tags.component.html',
  styleUrl: './tags.component.scss',
})
export class TagsComponent {
  private readonly tagApi = inject(TagApiService);

  table = table({
    itemsFn: this.tagApi.getAdapter(),
    view: {
      itemName: 'Tag',
    },
    columns: {
      id: { label: 'ID' },
      name: { label: 'Title' },
      type: {
        label: 'Type',
        transform: (v) => (v == 0 ? 'Others' : 'Blog'),
        filterable: [
          {
            type: 'equal',
            key: 'Type',
            controlType: 'select',
            items: [
              { value: 0, label: 'Others' },
              { value: 1, label: 'Blog' },
            ],
          },
        ],
      },
    },
    actions: [
      {
        type: 'icon',
        content: 'edit',
        action: (item: TagEntity) => dialog$.tag({ tag: item }).afterSubmit(),
      },
      {
        type: 'icon',
        content: 'trash',
        action: (item) => dialog$.deletePrompt(false, { itemName: 'Tag' }).action(() => this.tagApi.deleteTag(item.id)),
      },
    ],
    events: {
      add: () => dialog$.tag().afterSubmit(),
    },
  });
}
